import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { PopupService } from "@ng-bootstrap/ng-bootstrap/util/popup";
import { CompanydetailsComponent } from "../companydetails/companydetails.component";
import { Account } from "../constants/account.enum";
import { ConfirmDialogService } from "../services/shared/confirm-dialog/confirm-dialog.service";
import { UtilityServiceService } from "../services/utility-service.service";
import { UploaddocumentComponent } from "../uploaddocument/uploaddocument.component";
import { ToastrService } from "ngx-toastr";
import { AuthWebService } from "../services/authweb.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { OcasService } from "app/ocas/Service/ocas.service";
import { CarrierService } from "app/services/carrier.service";

@Component({
  selector: "app-carrier-stepper",
  templateUrl: "./carrier-stepper.component.html",
  styleUrls: ["./carrier-stepper.component.scss"],
})
export class CarrierStepperComponent implements OnInit {
  background1 = "var(--sapphire)";
  background2 = "var(--background)";
  background3 = "var(--background)";
  background4 = "var(--background)";

  isProgress1 = true;
  isProgress2 = false;
  isProgress3 = false;
  isProgress4 = false;

  isStepper1 = false;
  isStepper2 = false;
  isStepper3 = false;
  isStepper4 = false;
  isEd:boolean=false;
  sub: any;
  step: string;
  acc = Account;
  iconCtrl = 1;
  displayFlag: boolean = false;
  status: any;
  @Input("ctrlData") ctrlData: any;
  isExternalRole: boolean = true;
  carrierIdForQuestionnaire: any;
  ocas: boolean = false;
  switchCtrl: number;
  stepperCounter = 0;
  carrierNames: string = "";
  carrierAccNumber: string = "";
  carrierType: string = "";
  carrierId: any;
  //ctrlData: any = { carrierId: 0, isApproval: false, currentActive: 1, action: 0, ctrlAction: 0, data: {} };
  @ViewChild(CompanydetailsComponent) company: CompanydetailsComponent;

  @ViewChild(UploaddocumentComponent) document: UploaddocumentComponent;

  @ViewChild('ocasTabs') activeTab;

  constructor(
    private router: Router,
    private route: ActivatedRoute,  private carrierService: CarrierService,
    private toastService: ToastNotificationService,
    private _ocas:OcasService,
    public utility: UtilityServiceService,
    private authWebService: AuthWebService,
    private msg: ToastrService,
    private confirmDialogService: ConfirmDialogService
  ) {}

  ngOnInit() {
    if (!this.ctrlData) {
      this.ctrlData = {
        carrierId: 0,
        isApproval: false,
        currentActive: 1,
        action: 0,
        ctrlAction: 0,
        xstatus: 0,
        data: {},
      };
      this.isEd =this.router.url.indexOf('add') > 0;
      if (this.router.url.indexOf('edit') > 0){
        this.route.params.subscribe((params: Params) => {
          this.carrierService.getCarrierById(params['id']).subscribe((data:any) => {
            this.carrierNames = data.name;
        this.carrierAccNumber = data.carrier_code;
        this.carrierType = data.carrier_type_name;
      });})}
      this.route.paramMap.subscribe((params: Params) => {
        if (params["status"] != "") {
          this.status = params.get("status");
          if (this.status == 1) {
            this.utility.isProcessAccounts = false;
            this.ctrlData.isApproval = true;
            this.ctrlData.carrierId = params.get("id");
            this.ctrlData.xstatus = 1;
          } else if (this.status == 2) {
            this.ctrlData.isApproval = true;
            this.utility.isProcessAccounts = true;
            this.ctrlData.carrierId = params.get("id");
            this.ctrlData.xstatus = 1;
          }
        }
        if(this.router.url.includes('carrier/account/edit')){
          this.utility.ctrlPages[this.utility.acc.First].carrierId = params.get("id");
          console.log(this.utility.ctrlPages[this.utility.acc.First].carrierId)
       
     
        }
      });

     
    }
    
    this.preprocessing();

    if (!this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isExternalRole = false;
    }
    if(this.router.url.includes('carrier/account/edit')){
      setTimeout(() => {
        this.route.paramMap.subscribe((params: Params) => {
      
          this.utility.ctrlPages[this.utility.acc.First].carrierId = params.get("id");
         console.log(params.get("id"))
        
      });
      }, 0);

  }
  }


  landing() {
    this.utility.landingPage();
  }

  checkRequiredDocument(): boolean {
    if (this.document.isDocUnavail) {
      return false;
    }

    for (let i = 0; i < this.document.DocTypesList.length; i++) {
      for (let x = 0; x < this.document.DocTypesList.length; x++) {
        if (
          this.document.DocTypesList[i].is_mandatory &&
          !this.document.UserDocuments[x]?.document_type_id
        ) {
          this.toastService.error(
            this.document.DocTypesList[i].description + " is required",
            "Documents Upload"
          );
          return true;
        }
      }
    }
  }
  tab(tab){
   console.log(this.activeTab)
  }
  jumpToReview() {
    if (this.router.url.indexOf("edit") != -1) {
      this.hideStepOneFromBeingActive();
      this.hideStepTwoFromBeingActive();
      this.hideStepThreeFromBeingActive();
      this.isStepper4 = true;
      this.isProgress4 = true;
      
    }
  }

  jumpToInfo() {
    if (this.router.url.indexOf("edit") != -1) {
      setTimeout(() => {
        document.getElementById("stepperNextBtn4").click();
      }, 100);
      setTimeout(() => {
        // document.getElementById('stepperPrevBtn2').click();
        this.previous(3);
        this.prevHideFour();
        this.prevHideThree();
        this.prevHideTwo();
      }, 100);
    }
  }

  jumpToOCAS() {
    if (this.router.url.indexOf("edit") != -1) {
      this.hideStepOneFromBeingActive();
      this.hideStepTwoFromBeingActive();
      this.isStepper4 = false;
      this.isProgress4 = false;
      this.stepThreeActiveTab();
    }
  }

  jumpToDoc() {
    if (this.router.url.indexOf("edit") != -1) {
      this.hideStepOneFromBeingActive();
      this.hideStepThreeFromBeingActive();
      this.isStepper4 = false;
      this.isProgress4 = false;
      this.isStepper3 = false;
      this.isProgress3 = false;
      this.stepTwoActiveTab();

    }
  }

  saveCarrierID(event) {
    this.carrierIdForQuestionnaire = event;
  }

  onSaveQuestionnaire(event) {
    switch (event) {
      case "next":
          this.hideStepThreeFromBeingActive();
          this.stepFourActiveTab();
        break;
      case "back":
        this.previous(3);
        break;
      default:
        this.next(4);
        break;
    }
  }

  onPrevNextDepot(event) {
    switch (event) {
      case "next":
        document.getElementById("depotLink").className = "nav-link";
        document.getElementById("depots").className = "tab-pane fade";
        document.getElementById("driverLink").className += " active";
        document.getElementById("drivers").className += " show active";
        break;
      case "back":
        document.getElementById("driverLink").className = "nav-link";
        document.getElementById("drivers").className = "tab-pane fade";
        document.getElementById("vehicleLink").className += " active";
        document.getElementById("vehicles").className += " show active";
        break;
    }
  }
  onPrevNextVehicle(){

  }
activeDriver(){
  document.getElementById("vehicleLink").className = "nav-link";
    document.getElementById("vehicles").className = "tab-pane fade";
        document.getElementById("driverLink").className += " active";
        document.getElementById("drivers").className += " show active";
}
  checkOCAS(event) {
    this.ocas = event.val;
    console.log(this.ocas);
  }

  onPrevNextDriver(event) {
    switch (event) {
      case "next":
        document.getElementById("driverLink").className = "nav-link";
        document.getElementById("drivers").className = "tab-pane fade";
        document.getElementById("vehicleLink").className += " active";
        document.getElementById("vehicles").className += " show active";
        break;
      case "back":
        document.getElementById("driverLink").className = "nav-link";
        document.getElementById("drivers").className = "tab-pane fade";
        document.getElementById("depotLink").className += " active";
        document.getElementById("depots").className += " show active";
        break;
    }
  }

  next(event: any) {
    switch (event) {
      case 1:
        this.hideStepOneFromBeingActive();
        this.stepTwoActiveTab();
        break;
      case 2:
        if (!this.isExternalRole) {
          this.hideStepTwoFromBeingActive();
          this.stepThreeActiveTab();
        } else {
          if (!this.checkRequiredDocument()) {
            // Check if any of the docs is required!
            this.hideStepTwoFromBeingActive();
            this.stepThreeActiveTab();
          }
        }
        break;
      case 3:

        
        if(this._ocas.stage == 'depot'){
          document.getElementById('goToDriversOcas').click();
          if(this.utility.carrierDepotList == 0){
             this.toastService.error('Please add at least one depot!','Depot Needed');
             return
           }else{
            this._ocas.stage = 'driver';
           }
          return
        }
        if(this._ocas.stage == 'driver'){
          this._ocas.stage = 'vehicle';
          document.getElementById('gotoVehicleOcas').click();
          return
        }
        if(this._ocas.stage == 'vehicle'){
          this._ocas.stage = 'questionnaire';
          if(this.utility.checkFreight == 1 && this.utility.checkNoOfVehicles == 0){
            return this.toastService.error('Please add at least one vehicle!','Carrier type is Freight')
          }
        document.getElementById("depotLink").className = "nav-link";
        document.getElementById("depots").className = "tab-pane fade";
        document.getElementById("vehicleLink").className = "nav-link"
        document.getElementById("questionnaireLink").className += " active";
        document.getElementById("questionnaires").className += " show active";
        return
          
          
        }
        if(this._ocas.stage == 'questionnaire'){
          document.getElementById('saveQuesOcas').click();
        }
        
        break;
      default:
      //this.done();
    }
  }

  previous(event: any) {
    this.stepperCounter = 0 ;

    console.log("Stepper:", event);
    console.log("Stage:", this._ocas.stage);
    switch (event) {
      case 2:
        this.prevHideTwo();
        break;
      case 3:
        if(this._ocas.stage == 'questionnaire'){
          this._ocas.stage = 'vehicle';
        document.getElementById("questionnaireLink").className = "nav-link";
        document.getElementById("questionnaires").className = "tab-pane fade";
        document.getElementById("vehicleLink").className += " active";
        document.getElementById("vehicles").className += " show active";
          return
        }
        if(this._ocas.stage == 'depot'){
          this._ocas.stage = 'depot';
          // document.getElementById('goBackToQuestionnaireOcas').click();
          this.prevHideThree();
          return
        }
        if(this._ocas.stage == 'driver'){
          this._ocas.stage = 'depot';
          document.getElementById('goBacktoVehicleOcas').click();
          return
        }
        if(this._ocas.stage == 'vehicle'){
          this._ocas.stage = 'driver';
          this.activeDriver();

        }
        
        break;
      default:
        this.prevHideFour();
    }
  }

  stepTwoActiveTab() {
    const stepTwo = <HTMLElement>document.getElementsByClassName("step-two")[0];
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
  }

  stepThreeActiveTab() {
    const stepTwo = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
  }

  stepFourActiveTab() {
    const stepFour = <HTMLElement>(
      document.getElementsByClassName("step-four")[0]
    );
    stepFour.style.fontSize = "20px";
    stepFour.style.fontSize = "bold";
  }

  hideStepOneFromBeingActive() {
    this.isStepper2 = true;
    this.isProgress1 = false;
    this.background2 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-one")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepTwoFromBeingActive() {
    this.isStepper3 = true;
    this.isStepper2 = false; // Hide tab 2
    this.isProgress2 = true;
    this.background3 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-two")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepThreeFromBeingActive() {
    this.isStepper4 = true;
    this.isStepper3 = false; // Hide tab 3
    this.isProgress3 = true;
    this.background4 = "var(--sapphire)";
    const element = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  done() {
    this.isProgress3 = true;
    const element = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  stepOneIsActiveAgain() {
    const element = <HTMLElement>document.getElementsByClassName("step-one")[0];
    element.style.fontSize = "20px";
    element.style.fontWeight = "bold";
  }

  stepTwoIsActiveAgain() {
    const element = <HTMLElement>document.getElementsByClassName("step-two")[0];
    element.style.fontSize = "20px";
    element.style.fontWeight = "bold";
  }

  prevHideTwo() {
    this.background3 = "var(--background)";
    const element = <HTMLElement>document.getElementsByClassName("step-two")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
    this.isProgress1 = true;
    this.isProgress2 = false;
    this.isStepper2 = false;
    this.stepOneIsActiveAgain();
  }

  prevHideThree() {
    this.background4 = "var(--background)";
    const element = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
    this.isProgress2 = true;
    this.isStepper2 = true;
    this.isProgress3 = false;
    this.isStepper3 = false;
    this.stepTwoIsActiveAgain();
  }

  prevHideFour() {
    this.stepThreeActiveTab();
    const stepThree = <HTMLElement>(
      document.getElementsByClassName("step-four")[0]
    );
    stepThree.style.fontSize = "16px";
    stepThree.style.fontWeight = "lighter";
    this.isStepper3 = true;
    this.isStepper4 = false;
  }

  ngAfterViewInit() {}

  preprocessing = () => {
    if (this.ctrlData.isApproval) {
      this.utility.activeTab = 3;
      this.utility.ctrlPages[Account.First].carrierId = this.ctrlData.carrierId;
      this.utility.ctrlPages[Account.First].isEdit = true;
      this.utility.docCtrl = true;
      this.utility.confirmCtrl = true;
    } else {
      //this.utility.isView = false;
      this.utility.activeTab = 1;
      this.utility.isBtnVisible = true;
      this.sub = this.route.params.subscribe((params) => {
        this.utility.switchOnVisibility(Account.First);
        this.utility.ctrlPages[Account.First].carrierId = +params["id"];
        if (this.router.url.indexOf("edit") != -1) {
          this.utility.ctrlPages[Account.First].isEdit = true;
          this.utility.docCtrl = true;
          this.utility.confirmCtrl = true;
        } else {
          this.utility.ctrlPages[Account.First].isEdit = false;
          this.utility.docCtrl = false;
          this.utility.confirmCtrl = false;
        }
      });
    }
  };

  onActive = (key = 1) => {
    if (key === 3) {
      if (this.document === undefined) {
        return this.msg.warning(
          "Please verify the documents first before comfirming your details!"
        );
      }
      for (let i = 0; i < this.document.DocTypesList.length; i++) {
        if (this.document.DocTypesList[i].is_mandatory) {
          return this.msg.warning(
            this.document.DocTypesList[i].description + " is required"
          );
        }
      }
    }
    this.iconCtrl = key;
    this.switchCtrl = key;
    this.toogle();
  };

  nextFrame = () => {
    let isEd =
      this.utility.ctrlPages[Account.First].carrierId > 0 ? true : false;
    /*
    if (isEd) {
      this.msgService.showYesNo('Save & Continue', 'Please note that the account change will need to be re-submitted for approval, do you want to continue?', '', 'Yes', 'No')
        .subscribe((isConfirmed) => {
          if (isConfirmed) {
            this.nextFrameDeleg();
          } else {
            this.utility.landingPage();
          }
        });
    }
    else {
      this.nextFrameDeleg();
    }
    */
    this.nextFrameDeleg();
  };
  back() {
    this.utility.activeTab = 1;
  }
  nextFrameDeleg() {
    this.document;
    var self = this;
    var count = 0;
    $(document).ready(function () {
      if ($(".file-upload").length > 0) {
        $(".file-upload").each(function () {
          var id = this.id;
          if ($("#" + id).val() == "" || $("#" + id).val() == undefined) {
            var docDescId = id + "-desc";
            var documentName = $("#" + docDescId).val();
            self.msg.warning(documentName + " is required!");
            return false;
          }
          if ($(".file-upload").length - 1 == count) {
            self.utility.activeTab = 3;
            self.utility.confirmCtrl = true;
            self.iconCtrl = 3;
          }
          count++;
        });
      } else {
        self.utility.activeTab = 3;
        self.utility.confirmCtrl = true;
        self.iconCtrl = 3;
      }
    });
  }
  toogle = (key = 1) => {
    if (this.utility.isChanged) {
      // this.msgService.showYesNo('Unsaved Changes Detected', 'You have unsaved data. Do you wish to save your data?', 'Unsaved data will be lost.').subscribe(isConfirmed => {
      //   if (isConfirmed) {
      //     if (this.company)
      //       this.company.autoSave(this.switchCtrl);
      //   } else {
      //     this.utility.isChanged = false;
      //     this.utility.activeTab = this.switchCtrl;
      //   }
      //   if (this.switchCtrl == 2) {
      //     //this.utility.activeTab = this.switchCtrl;
      //     $('.nav-tabs a:eq(1)').tab('show');
      //     //this.utility.isChanged = false;
      //     //else {
      //     //  $('.nav-tabs a:eq(0)').tab('show');
      //     //}
      //   } else if (this.switchCtrl == 3) {
      //     //this.utility.activeTab = this.switchCtrl;
      //     $('.nav-tabs a:eq(2)').tab('show');
      //     //this.utility.isChanged = false;
      //   }
      // })
      this.confirmDialogService.confirmThis(
        "You have unsaved data. Do you wish to save your data?",
        () => {
          if (this.company) this.company.autoSave(this.switchCtrl);

          if (this.switchCtrl == 2) {
            //this.utility.activeTab = this.switchCtrl;
            //   $('.nav-tabs a:eq(1)').tab('show');
            //this.utility.isChanged = false;
            //else {
            //  $('.nav-tabs a:eq(0)').tab('show');
            //}
          } else if (this.switchCtrl == 3) {
            //this.utility.activeTab = this.switchCtrl;
            //   $('.nav-tabs a:eq(2)').tab('show');
            //this.utility.isChanged = false;
          }
        },
        () => {
          this.utility.isChanged = false;
          this.utility.activeTab = this.switchCtrl;
        }
      );
    } else {
      this.utility.activeTab = this.switchCtrl;
    }
  };

  onPrevNextQ() {
    this._ocas.stage = 'questionnaire';
    if(this.utility.checkFreight == 1 && this.utility.checkNoOfVehicles == 0){
      return this.toastService.error('Please add at least one vehicle!','Carrier type is Freight')
    }
  document.getElementById("depotLink").className = "nav-link";
  document.getElementById("depots").className = "tab-pane fade";
  document.getElementById("vehicleLink").className = "nav-link"
  document.getElementById("questionnaireLink").className += " active";
  document.getElementById("questionnaires").className += " show active";
  return

  }

  onDepot() {
    document.getElementById("driverLink").className = "nav-link";
    document.getElementById("drivers").className = "tab-pane fade";
    document.getElementById("vehicleLink").className = "nav-link";
    document.getElementById("vehicles").className = "tab-pane fade";
    document.getElementById("questionnaireLink").className = "nav-link";
    document.getElementById("questionnaires").className = " tab-pane fade";
    document.getElementById("depotLink").className += " active";
    document.getElementById("depots").className += " show active";
}

onDrivers() {
  document.getElementById('goToDriversOcas').click();
  if(this.utility.carrierDepotList == 0){
    this.toastService.error('Please add at least one depot!','Depot Needed');
    return
  }
  this._ocas.stage = 'driver';
  document.getElementById("depotLink").className = "nav-link";
  document.getElementById("depots").className = "tab-pane fade";
  
}

onVehicles() {
    document.getElementById("depotLink").className = "nav-link";
  document.getElementById("depots").className = "tab-pane fade";
  document.getElementById("questionnaireLink").className = "nav-link";
  document.getElementById("questionnaires").className = " tab-pane fade";
  this._ocas.stage = 'vehicle';
  document.getElementById('gotoVehicleOcas').click();
  return

}
}
